import { render, staticRenderFns } from "./SuiviTicketAdmin.vue?vue&type=template&id=2797729f"
import script from "./SuiviTicketAdmin.vue?vue&type=script&lang=js"
export * from "./SuiviTicketAdmin.vue?vue&type=script&lang=js"
import style0 from "./SuiviTicketAdmin.vue?vue&type=style&index=0&id=2797729f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports